import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { getTestIds } from '../../../../utils/TestIds';
import { Column } from '../../../Layout';
import { MobileRecordCard } from '../../../MobileRecordCard';
import { Typography } from '../../../Typography';
import { ActionsCell } from '../cells/ActionsCell/ActionsCell';
import { SchemaCell } from '../cells/SchemaCell/SchemaCell';
import { isCellValuePresent } from '../mobileCard/mobileCard';
import { nestedCardRows, withNestedRows } from './nestedCardRows';
export function TableMobileCards(param) {
    let { items, getRowId, fields, gray, rowActions, actionSlot, badgeColumn, mainColumn, now, children, testId } = param;
    const testIds = getTestIds(testId);
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 8,
        testId: testId,
        children: [
            items.map((row, index)=>{
                var _ref, _row_subItems;
                const rowId = (_ref = getRowId === null || getRowId === void 0 ? void 0 : getRowId(row, index)) !== null && _ref !== void 0 ? _ref : index;
                const cardTestId = testIds.card(rowId);
                return /*#__PURE__*/ _jsx(MobileRecordCard, {
                    skin: gray ? 'mobileGray' : undefined,
                    actions: rowActions != null ? /*#__PURE__*/ _jsx(ActionsCell, {
                        variant: "card",
                        actions: rowActions,
                        row: row,
                        testId: cardTestId && "".concat(cardTestId, "-actions")
                    }) : badgeColumn != null && isCellValuePresent(row, badgeColumn) ? /*#__PURE__*/ _jsx(SchemaCell, {
                        column: badgeColumn,
                        row: row,
                        now: now,
                        testId: cardTestId && "".concat(cardTestId, "-badge")
                    }) : undefined,
                    footer: actionSlot === null || actionSlot === void 0 ? void 0 : actionSlot(row, index),
                    inlineItems: fields.filter((field)=>field.inline && isCellValuePresent(row, field.column)).map((field)=>{
                        const name = String('name' in field.column ? field.column.name : '');
                        return {
                            key: name,
                            testId: cardTestId && "".concat(cardTestId, "-inline-").concat(name),
                            content: /*#__PURE__*/ _jsx(SchemaCell, {
                                skin: "secondary",
                                column: field.column,
                                row: row,
                                now: now,
                                testId: cardTestId && "".concat(cardTestId, "-value-").concat(name)
                            })
                        };
                    }),
                    rows: withNestedRows({
                        own: fields.filter((field)=>!field.inline && isCellValuePresent(row, field.column)).map((field)=>{
                            const name = String('name' in field.column ? field.column.name : '');
                            return {
                                key: name,
                                spaceBetween: field.spaceBetween,
                                dividerBefore: field.dividerBefore,
                                emphasis: field.emphasis,
                                testId: cardTestId && "".concat(cardTestId, "-row-").concat(name),
                                dividerTestId: cardTestId && "".concat(cardTestId, "-divider-").concat(name),
                                label: field.label != null ? (labelClassName)=>/*#__PURE__*/ _jsx(Typography, {
                                        skin: field.emphasis === 'strong' ? undefined : 'secondary',
                                        weight: field.emphasis === 'strong' ? 'normal' : undefined,
                                        className: labelClassName,
                                        testId: cardTestId && "".concat(cardTestId, "-label-").concat(name),
                                        children: field.hideColon ? field.label : "".concat(field.label, ":")
                                    }) : undefined,
                                value: (valueClassName)=>/*#__PURE__*/ _jsx("div", {
                                        className: valueClassName,
                                        children: /*#__PURE__*/ _jsx(SchemaCell, {
                                            skin: field.emphasis === 'strong' ? undefined : 'secondary',
                                            weight: field.emphasis === 'strong' ? 'normal' : undefined,
                                            column: field.column,
                                            row: row,
                                            now: now,
                                            testId: cardTestId && "".concat(cardTestId, "-value-").concat(name)
                                        })
                                    })
                            };
                        }),
                        nested: nestedCardRows({
                            nested: (_row_subItems = row.subItems) !== null && _row_subItems !== void 0 ? _row_subItems : [],
                            mainColumn,
                            valueField: fields[fields.length - 1],
                            now,
                            cardTestId
                        })
                    }),
                    testId: cardTestId
                }, rowId);
            }),
            children
        ]
    });
}
